import React from 'react'
import { LRHeader } from '../style/LifetimeReplacement.css'

const Header = ({
  orderDetails,
  item,
}) => {
  const {
    merchant_order_id: orderNumber,
    order_date: orderDate,
  } = { ...orderDetails }
  return (
    <LRHeader>
      <div>
        <span>
          Order Number:&nbsp;
          {orderNumber}
        </span>
        <span>
          Part no.:&nbsp;
          {item?.partNumber}
        </span>
      </div>
      <div>
        <span>
          Date Purchased:&nbsp;
          {orderDate}
        </span>
      </div>
    </LRHeader>
  )
}

export default Header
